import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordResetDialog } from "../../../components/dialogs/presets/passwordResetDialog";
import { EmailField } from "../../../components/input/fields/email-filed";
import TextField from "../../../components/input/fields/text-field";
import logo from '../../../content/img/logo.png';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { toast } from "react-toastify";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth"; 
import { useTranslation } from "react-i18next";

const Login = () => {
    const { t } = useTranslation();
    const auth = getAuth();
    const navigator = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    /* Functions */
    const submit = () => {
      if (!(email && password)) {
        toast.error(t("AllFieldsRequired")); 
        return;
      }
      if (
        !String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      ) {
        toast.error(t("InvalidEmail")); 
        return;
      }

      signInWithEmailAndPassword(auth, email, password)
        .then(() => {
          setShowSuccessMessage(true);
          setTimeout(() => {
            setShowSuccessMessage(false);
            navigator("/admin/dashboard");
          }, 2000); 
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          switch (errorCode) {
            case "auth/user-not-found":
              toast.error(t("UserNotRegistered")); 
              break;
            case "auth/wrong-password":
              toast.error(t("InvalidCredentials")); 
              break;
            case "auth/too-many-requests":
              toast.error(t("TooManyRequests")); 
              break;
            default:
              toast.error(t("SomethingWentWrong") + errorMessage); 
              break;
          }
        });
    };

    return (
            <div className="container-login">
                <div className="row justify-content-center">
                    <div className="col-md-4">
                        <div className="mt-3">
                            <img
                                className="w-100 h-auto"
                                alt="Feeling Italy logo"
                                src={logo}
                            />
                        </div>
                            <h1 className="text-center title title-login">
                                {t("LoginBackOffice")}  
                            </h1>
                        <div className="d-flex flex-column mt-4">
                            <EmailField
                                onChange={(e) => setEmail(e.target.value)}
                                label={t("Email")}  
                                placeholder={t("Insert")}  
                                inputClassName={"form-control input-login grey-input"}
                                className={""}
                            />
                            <div className="d-flex flex-column mt-4 position-relative">
                                <TextField
                                    type={isPasswordVisible ? "text" : "password"}
                                    label={t("Password")}  
                                    placeholder={t("Insert")}  
                                    inputClassName={"form-control input-login grey-input"}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                    }}
                                    value={password}
                                />
                                <button
                                    className="btn-eyePassword position-absolute "
                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                >
                                    {!isPasswordVisible ? <IoEyeOff className="fs-6 mt-2"/> : <IoEye className="fs-6 mt-2"/>}
                                </button>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                            <PasswordResetDialog />
                        </div>
                        <div className="w-full">
                            <button onClick={submit} className="background-black text-white mt-3 text-uppercase py-3 fs-6 px-5 w-100 border-none">
                                {t("Login")}  
                            </button>
                        </div>
                        {showSuccessMessage && (
                             <div className="alert alert-success text-center mt-4 mx-auto no-border-radius w-50">
                                {t("LoginSuccess")}  
                            </div>
                        )}
                    </div>
                </div>
            </div>
    );
};

export default Login;
